import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import logoOnDark from "@portal/app/_components/resources/images/dreambound_logo_rebrand_white.svg";
import logoOnLight from "@portal/app/_components/resources/images/dreambound_logo_rebrand_blue.svg";
import NextLink from "next/link";
import { getUrls } from "@portal/app/_common/lib/urls";

export const DreamLogo = ({
  width = 0,
  height = 0,
  isOnDarkBackground = false,
  clickable = false,
  ...propsToBoxWrapper
}: React.ComponentProps<typeof Box> & {
  // Only provide one of width or height; ratio calculated automatically
  width?: number;
  height?: number;
  isOnDarkBackground?: boolean;
  clickable?: boolean;
}) => {
  const setWidth = width || height * 8 || 200;
  const setHeight = height || width * 0.125 || 25;

  const image = isOnDarkBackground ? logoOnDark : logoOnLight;

  const img = (
    <img
      src={image.src}
      alt="Dreambound"
      width={setWidth}
      height={setHeight}
      style={{ color: "transparent" }}
    />
  );
  return (
    <Wrapper {...propsToBoxWrapper} style={{ height: setHeight }}>
      {clickable ? (
        <NextLink href={clickable ? getUrls().Home() : "#"} passHref>
          {img}
        </NextLink>
      ) : (
        img
      )}
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  position: relative;
`;
